const REDIS_REDIRECTS_HOST = process.env.REDIS_REDIRECTS_HOST || 'ecom_obr_base-redis';
const REDIS_PORT = process.env.REDIS_PORT || 6379;
const REDIS_DB = process.env.REDIS_DB || 1;
const TOKEN = process.env.TOKEN;
const CACHE_PREFIX = process.env.CACHE_PREFIX || 'cache_prod';
const { CACHE_EXCLUSIONS } = require('../constants');
import { logTime } from '../utils/logtime.js';

export default async (req, res, next) => {
    // const cookies = req.headers.cookie || '';
    // const parseCookies = str =>
    //     str.split('; ').reduce((acc, cookie) => {
    //         const [key, value] = cookie.split('=');
    //         acc[key] = decodeURIComponent(value);
    //         return acc;
    //     }, {});

    // let cookiesObject = parseCookies(cookies);

    // if (!cookiesObject.firstVisit) {
    //     next();
    //     return;
    // }

    let redis;
    try {
        if (req.url === '/' || req.url === '/ro' || req.url === '/ro/' || req.url === '/en') {
            next();
            return;
        }

        const shouldExclude = CACHE_EXCLUSIONS.some(element => req.url.startsWith(element));
        if (shouldExclude) {
            next();
            return;
        }

        const [path] = req.url.split('?');

        const cleanedPath = path?.replace(/^https?:\/\/[^\/]+/, '');

        const slashCount = (cleanedPath.match(/\/{2,}/g) || []).length;

        if (slashCount > 0) {
            const newUrl = '/' + (req.url.includes('?') ? '?' + req.url.split('?')[1] : '');
            res.writeHead(301, { Location: newUrl });
            res.end();
            return;
        }

        console.log('[ Redirects middleware ] | Processing...');
        console.log('[ Redirects middleware ] | Request URL:', req.url);
        const startTime = process.hrtime();

        logTime('[ Redirects middleware ] | Start importing redis', startTime);
        const { Redis } = await import('ioredis');
        logTime('[ Redirects middleware ] | Redis imported', startTime);

        logTime('[ Redirects middleware ] | Connecting to redis', startTime);
        redis = new Redis({
            host: REDIS_REDIRECTS_HOST,
            port: REDIS_PORT,
            db: REDIS_DB
        });

        logTime('[ Redirects middleware ] | Connected to redis', startTime);
        // process redirects
        let [url, getParams] = req.url.split('?');

        console.log(url, 'url');
        console.log(getParams, 'getParams');

        // Используем объект URL для корректного парсинга
        // const urlObject = new URL(req.url, `${req.protocol}://${req.headers.host}`);
        // let url = urlObject.pathname;
        // const getParams = urlObject.search ? urlObject.search : ''; // Включает знак "?" и параметры запроса

        // Проверяем, присутствует ли слэш перед вопросительным знаком
        // if (url && !url.endsWith('/') && getParams) {
        //     url += '/';
        // }

        let keyToFindRedirect = `${CACHE_PREFIX}_redirects_${TOKEN}`;
        // let keyToFindRedirect = `test`;
        let specificKey = `${url}`;

        if (keyToFindRedirect?.endsWith('/')) {
            keyToFindRedirect = keyToFindRedirect.slice(0, -1);
        }

        console.log(keyToFindRedirect, 'keyToFindRedirect');
        console.log(specificKey, 'specificKey');

        logTime(`[ Redirects middleware ] | Getting redirect by key: ${keyToFindRedirect}`, startTime);
        let redirectLink = await redis.hget(keyToFindRedirect, specificKey);

        if (!redirectLink) {
            specificKey += '/';
            console.log('if not redirectLink');
            redirectLink = await redis.hget(keyToFindRedirect, req.url);
        }

        logTime('[ Redirects middleware ] | Redirect has been get', startTime);

        logTime('[ Redirects middleware ] | Disconnecting from redis', startTime);

        redis.disconnect();
        if (redirectLink) {
            let parsedRedirectLink;

            try {
                parsedRedirectLink = JSON.parse(redirectLink);
                console.log('try block');
                if (getParams) {
                    const [_, parsedGetParams] = parsedRedirectLink.split('?');
                    if (!parsedGetParams) {
                        parsedRedirectLink += '?' + getParams;
                    }
                }
            } catch (error) {
                console.log('error');
                console.log('fetch block');
                parsedRedirectLink = redirectLink;
                if (getParams) {
                    const [_, parsedGetParams] = parsedRedirectLink.split('?');
                    if (!parsedGetParams) {
                        parsedRedirectLink += '?' + getParams;
                    }
                }
            }

            logTime(
                `[ Redirects middleware ] | Redirect found by key: ${keyToFindRedirect}, to: ${parsedRedirectLink}`,
                startTime
            );
            res.writeHead(301, { Location: parsedRedirectLink });
            res.end();
        } else {
            next();
        }
    } catch (e) {
        // Close the connection immediately
        console.log('[ Redirects middleware ] | Error while processing redirects: ', e);
        if (redis) {
            redis.disconnect();
            console.log('[ Redirects middleware ] | Disconnecting from redis in catch');
        }
        next();
    }
};
